import { useState } from "react";

import { Popover, Box, Text, Anchor, Stack, Flex } from "@mantine/core";

import cx from "clsx";

import styles from "@scss/custom-components/current-dataset-popover.module.scss";

interface Dataset {
  name: string;
  url: string;
  elapsed: string;
}
type StatusVariant = "live" | "replaying";
interface CwiggoCurrentDatasetPopoverProps {
  cwiggoDatasets: Dataset[];
  variant?: StatusVariant;
  w?: string | number;
}

export const CustomCurrentDatasetPopover: React.FC<
  CwiggoCurrentDatasetPopoverProps
> = ({ cwiggoDatasets, variant = "live", w = "auto" }) => {
  const [opened, setOpened] = useState(false);

  if (cwiggoDatasets.length === 0) return null;

  return (
    <Popover opened={opened} onChange={setOpened} position="bottom-end">
      <Popover.Target>
        <Box
          onClick={() => setOpened((o) => !o)}
          className={cx(styles.currentDatasetBadge, {
            [styles["currentDatasetBadge--live"]]: variant === "live",
            [styles["currentDatasetBadge--replaying"]]: variant === "replaying",
          })}
          w={w}
        >
          <Flex justify="space-between" align="center" w="100%">
            <Flex align="center" gap="xs" mr="md">
              <Box className={styles.circle} />
              {cwiggoDatasets.length} DATASET{cwiggoDatasets.length > 1 && "S"}{" "}
              {variant === "replaying" ? "REPLAYING" : "LIVE"} NOW
            </Flex>
            <></>
          </Flex>
        </Box>
      </Popover.Target>

      <Popover.Dropdown
        className={cx(styles.dropdown, {
          [styles["dropdown--live"]]: variant === "live",
          [styles["dropdown--replaying"]]: variant === "replaying",
        })}
      >
        <Stack>
          {cwiggoDatasets.map((dataset, index) => (
            <Anchor
              key={index}
              href={dataset.url}
              target="_blank"
              className={styles.anchor}
            >
              <Text size="sm" className={styles.name}>
                {dataset.name}
              </Text>
              <Text size="xs" className={styles.timeElapsed}>
                Elapsed: {dataset.elapsed}
              </Text>
            </Anchor>
          ))}
        </Stack>
      </Popover.Dropdown>
    </Popover>
  );
};

export default CustomCurrentDatasetPopover;
